import Backbone from 'backbone';

export const SuspendPatientModel = Backbone.Model.extend({

  defaults: {
    patient_id: '',
    reason_options: ''
  },

  initialize: function( options ) {
    this.channel = Backbone.Radio.channel( 'AppChannel' );
    this.app = this.channel.request( 'app' );
  }
});